
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface UserProfile {
  location: string | null;
  usda_zone: string | null;
}

interface UserCrop {
  commodity: string | null;
  variety: string | null;
  group_name: string | null;
  season: string | null;
  year: number;
  is_primary: boolean;
}

export const useUserFilters = () => {
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [userCrops, setUserCrops] = useState<UserCrop[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchUserData = async () => {
    try {
      setLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        setLoading(false);
        return;
      }

      // Fetch user profile
      const { data: profile } = await supabase
        .from("profiles")
        .select("location, usda_zone")
        .eq("user_id", user.id)
        .single();

      if (profile) {
        setUserProfile(profile);
      }

      // Fetch user crop preferences
      const { data: profileData } = await supabase
        .from("profiles")
        .select("id")
        .eq("user_id", user.id)
        .single();

      if (profileData) {
        const { data: crops } = await supabase
          .from("user_crop_categories")
          .select("commodity, variety, group_name, season, year, is_primary")
          .eq("user_id", profileData.id);

        if (crops) {
          setUserCrops(crops);
        }
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return {
    userProfile,
    userCrops,
    loading,
  };
};
